import { setFetchStartState } from '../fetchLoadable';
import { createNotLoaded } from '../Loadable/utils';
import * as actionTypes from './actionTypes';
export const activeUsersReducer = (state = {}, action) => {
    const { type, payload = {} } = action;
    switch (type) {
        case actionTypes.NEW_ACTIVE_USER: {
            const newActiveUsers = {};
            Object.keys(action.payload).forEach((tenant) => {
                const users = state[tenant];
                const newUsers = action.payload[tenant];
                if (!users) {
                    newActiveUsers[tenant] = newUsers;
                    return;
                }
                const filteredUsers = newUsers.filter((newUser) => {
                    return !users.find((user) => user.wsId === newUser.wsId);
                });
                newActiveUsers[tenant] = [...users, ...filteredUsers];
            });
            return Object.assign({}, newActiveUsers);
        }
        case actionTypes.NEW_USER_ACTIVITY: {
            const users = state[payload.tenantId] || [];
            return Object.assign(Object.assign({}, state), { [payload.tenantId]: users
                    ? users.map((user) => {
                        if (user.wsId !== payload.wsId) {
                            return user;
                        }
                        const activities = user.activities.filter((activity) => activity.type !== payload.activity.type ||
                            activity.handle !== payload.activity.handle);
                        return Object.assign(Object.assign({}, user), { activities: [...activities, payload.activity] });
                    })
                    : [] });
        }
        case actionTypes.REMOVE_USER_ACTIVITY: {
            const users = state[payload.tenantId] || [];
            return Object.assign(Object.assign({}, state), { [payload.tenantId]: users.map((user) => user.wsId === payload.wsId
                    ? Object.assign(Object.assign({}, user), { activities: user.activities.filter((a) => a.type !== payload.data.type ||
                            a.handle !== payload.data.handle) }) : user) });
        }
        case actionTypes.USER_LEFT: {
            const newState = {};
            Object.keys(action.payload).forEach((tenant) => {
                const users = state[tenant] || [];
                newState[tenant] = users.filter((user) => action.payload[tenant].indexOf(user.wsId) === -1);
            });
            return Object.assign(Object.assign({}, state), newState);
        }
        case actionTypes.RESET_ACTIVE_USERS: {
            return {};
        }
        default:
            return state;
    }
};
export const usersReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_USER_BY_ID_START:
            return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign({}, setFetchStartState(state[payload.id], payload.res)) });
        case actionTypes.FETCH_USER_BY_ID_ERROR:
        case actionTypes.FETCH_USER_BY_ID_SUCCESS:
            return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign({}, payload.res) });
        default:
            return state;
    }
};
export const allUsersReducer = (state = createNotLoaded(), action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_ALL_USERS_START:
            return Object.assign({}, setFetchStartState(state, payload.res));
        case actionTypes.FETCH_ALL_USERS_SUCCESS:
        case actionTypes.FETCH_ALL_USERS_ERROR:
            return Object.assign({}, payload.res);
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map